import React from 'react'
import img2037 from '../components/images/lamazon.png'

const events = () => {
    return (

        <>
            <div className="row  m-2">
                <img src={img2037} alt='amazon' />
            </div>
            <div className="row m-2">
                <div className="col-sm ">

                    <h2 className='p-2'>Amazon Listing Services
                    </h2>
                    <p>Enhance your Amazon business with our specialized listing services designed to maximize your product visibility and sales. </p>
                </div>
                <div className="col-sm ">
                    {/* <img src={img201} alt='Queryimg' /> */}
                </div>
            </div>
            <ul >
                <h3 className='text-info'> Key Services :</h3>
                <li><b>•	Product Listing:</b> Create and optimize high-quality product listings to improve visibility and attract customers. </li>
                <li><b>•	Advertising Campaign:</b>Implement targeted ad campaigns to boost product exposure and ROI. </li>
                <li><b>•	Coupons:</b>Set up discount coupons to entice customers and encourage purchases. </li>
                <li><b>•	Promotion:</b> Design and manage effective promotional activities to increase sales.</li>
                <li><b>•	Brand Registry:</b>Protect your brand and build trust with Amazon’s Brand Registry. </li>
                <li><b>•	Brand Approval:</b>Navigate the brand approval process smoothly to expand your product offerings. </li>
                <li><b>•	Category Approval:</b> Ensure correct categorization for your products to enhance searchability. </li>
                <li><b>•	GTIN Exemption:</b> Obtain exemptions to list products without Global Trade Item Numbers (GTINs). </li>
                <li><b>•	Account Health:</b> Maintain a healthy account to avoid suspensions and comply with Amazon’s policies. </li>
                <li><b>•	Order Processing:</b> Efficiently manage orders from receipt to delivery for timely fulfillment. </li>
                <li><b>•	Payment Reconciliation:</b> Ensure accurate transaction recording and resolve payment discrepancies. </li>
                <li><b>•	Keyword Optimization:</b> Optimize keywords for better search rankings and increased visibility. </li>
                <li><b>•	Safety Claim:</b> Handle safety compliance and customer claims effectively. </li>
                <li><b>•	FBA Shipping Creation:</b>Optimize Fulfillment by Amazon (FBA) shipments for cost-effective logistics. </li>
                <li><b>•	Basic Training:</b>Equip your team with essential knowledge to manage your Amazon account effectively. </li>
                <li><b>•	Sales Boost:</b> Implement strategies to drive substantial sales growth and enhance market reach.</li>
            </ul>
        </>
    )
}

export default events